import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Tag } from '@/components'
import { LineTagType } from '@/components/LineItem/LineItem'
import { Priority, TicketListRow } from '@/types/Ticket'
import { getStatusTagClassName } from '@/views/Ticket/Tickets/Tickets.data'

export const HomeTicketListColumns = [
  {
    Header: 'Subject',
    accessor: 'subject',
    minWidth: 200,
    Cell: function Cell({ row }: any) {
      const { pathname } = useLocation()
      return (
        <div className="route-link ml-auto flex w-full items-center justify-center">
          <Link className="w-full" state={{ from: pathname }} to={`/tickets/${row.original.id}`}>
            <p className="pr-2 font-bold text-p-sm underline">{row.original.subject}</p>
          </Link>
        </div>
      )
    },
  },
  {
    Header: 'Priority',
    accessor: 'priority',
    width: 100,
    Cell: ({ value }: { value: Priority }) => {
      return (
        <div className="flex w-full items-center justify-center">
          <Tag className="text-p-sm" variant={getPriorityVariant(value)}>
            {value}
          </Tag>
        </div>
      )
    },
  },
  {
    Header: 'Type',
    accessor: 'ticketType',
    width: 100,
  },
  {
    Header: 'Reason',
    accessor: 'ticketReason',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'internalTicketStatus',
    width: 100,
    Cell: ({ value }: { value: Priority }) => {
      return (
        <div className="flex w-full items-center justify-center">
          <Tag className={getStatusTagClassName(value)} variant="none">
            {value}
          </Tag>
        </div>
      )
    },
  },
  {
    Header: 'Owner',
    accessor: 'assignee.fullName',
    width: 100,
  },
  {
    Header: 'Tags',
    Cell: ({ row }: { row: { original: TicketListRow } }) => {
      const value = row.original || {}

      const isStandby = !!value.reservation?.standby
      const isCorporateHousing = !!value.reservation?.professionalHousing
      const isDirect = !!value.home?.property?.landingDirect && !value.home?.property?.isAutopilot
      const isAutoPilot = !!value.home?.property?.isAutopilot

      return (
        <div className="flex w-full items-center justify-center">
          {isCorporateHousing && <Tag className=" mr-1 text-sm text-tag-green-dark tag-green-light">CoHo</Tag>}
          {isStandby && <Tag className="mr-1 text-sm text-tag-grey-dark tag-grey-light">Standby</Tag>}
          {isDirect && <Tag className="text-sm text-tag-yellow-dark tag-yellow-light">Direct</Tag>}
          {isAutoPilot && <Tag className="text-tag-purple-dark tag-purple-light text-sm">Autopilot</Tag>}
        </div>
      )
    },
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
    width: 120,
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        const time = formatInTimeZone(value, timezone, 'MMM. dd, yyyy, h:mmaaa')
        return time
      } catch (e) {
        return 'Invalid  Date'
      }
    },
  },
  {
    Header: 'Date Closed',
    accessor: 'closedAt',
    width: 120,
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (!value) {
        return ''
      }
      try {
        const time = formatInTimeZone(value, timezone, 'MMM. dd, yyyy, h:mmaaa')
        return time
      } catch (e) {
        return 'Invalid  Date'
      }
    },
  },
  {
    Header: 'Last Comment',
    accessor: 'lastCommentDatetime',
    width: 160,
    disableSortBy: true,
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        const time = formatInTimeZone(value, timezone, 'MMM. dd, yyyy, h:mmaaa')
        return time
      } catch (e) {
        return 'Invalid  Date'
      }
    },
  },
]

export const getPriorityVariant = (value: Priority): LineTagType => {
  if (value === Priority.HIGH) return 'error'
  if (value === Priority.LOW) return 'info'
  return 'warning'
}
